import styled from "styled-components/macro"

// lot of stuff with borders is done to achieve desired look
// and without this theres a scrollbar
export const TableStyle = styled.div`
  table {
    width: calc(100% - 2px);
  }
`
